import React from "react";
import {BrowserRouter} from "react-router";
import Application from "./Application";
import {permitsLogErrorToServer} from "./functions";
import {createRoot} from "react-dom/client";

createRoot(document.getElementById("root") as HTMLElement, {
	onUncaughtError: (e) => permitsLogErrorToServer(e)
}).render(
	<React.StrictMode>
		<BrowserRouter>
			<Application/>
		</BrowserRouter>
	</React.StrictMode>
);
